export default {
  searchStrategy: [
    { label: 'And', value: 'and' },
    { label: 'Or', value: 'or' }
  ],
  dateStrategy: [
    { label: 'from', value: 'bt' },
    { label: 'before', value: 'le' },
    { label: 'after', value: 'ge' },
    { label: 'in', value: 'eq' }
  ],
  numStrategy: [
    { label: 'between', value: 'bt' },
    { label: 'less than', value: 'le' },
    { label: 'more than', value: 'ge' },
    { label: 'equal to', value: 'eq' }
  ],
  textStrategy: [
    { label: 'includes', value: 'cs' },
    { label: 'starts with', value: 'sw' },
    { label: 'ends with', value: 'ew' },
    { label: 'is exactly', value: 'eq' },
    { label: 'dosn\'t include', value: 'ncs' },
    { label: 'dosn\'t start with', value: 'nsw' },
    { label: 'dosn\'t end with', value: 'new' },
    { label: 'is different from', value: 'neq' },
    { label: 'is set', value: 'nis' }
  ],
  booleanStrategy: [
    { label: 'Yes', value: 'yes' },
    { label: 'No', value: 'no' }
  ],
  countryStrategy: [
    { label: '', value: 'eq' }
  ],
  exhib_groupStrategy: [
    { label: '', value: 'eq' }
  ],
  genderStrategy: [
    { label: 'Male', value: 'm' },
    { label: 'Female', value: 'f' },
    { label: 'Female-Male', value: 'fm' }
  ],
  exhibition: [
    {label: 'Exhibition or catalog title', value: 'title_lower', type: 'text'},
    {label: 'Exhibition group', value: 'exhibition_group_lower', type: 'exhib_group'},
    {label: 'Exhibition first year', value: 'begin_year', type: 'date'},
    {label: 'Exhibition last year', value: 'end_year', type: 'date'},
    {label: 'Current country', value: 'country_lower', type: 'country'},
    {label: 'Former country', value: 'former_country', type: 'text'},
    {label: 'City', value: 'city_lower', type: 'text'},
    {label: 'Itinerancy', value: 'traveling', type: 'boolean'},
    {label: 'Exhibition space', value: 'space_lower', type: 'text'},
    {label: 'Catalog source', value: 'source_catalog_lower', type: 'text'},
    {label: 'Catalog language', value: 'catalog_language_lower', type: 'text'},
    {label: 'Catalog authors / contributors', value: 'contributor_lower', type: 'text'},
    {label: 'Notes du contributeur à la base Artl@s', value: 'notes_lower', type: 'text'}
  ],
  exhibitor: [
    {label: 'Name', value: 'name_lower', type: 'text'},
    {label: 'Firstname', value: 'first_name_lower', type: 'text'},
    {label: 'Nationality', value: 'nationality_lower', type: 'text'},
    {label: 'Birth city', value: 'city_b_lower', type: 'text'},
    {label: 'Birth country', value: 'country_b', type: 'country'},
    {label: 'Living city', value: 'city_lower', type: 'text'},
    {label: 'Living country', value: 'country', type: 'country'},
    {label: 'Birth date', value: 'year_b', type: 'date'},
    {label: 'Death date', value: 'year_d', type: 'date'},
    {label: 'Gender', value: 'gender_lower', type: 'gender'},
    {label: 'Exhibition title', value: 'exhibition_title_lower', type: 'text'},
    {label: 'Exhibition group', value: 'exhibition_group_lower', type: 'exhib_group'},
    {label: 'Exhibition first year', value: 'begin_year', type: 'date'},
    {label: 'Exhibition city', value: 'exhibition_city_lower', type: 'text'}
  ],
  exhibited_work: [
    {label: 'Title', value: 'title_lower', type: 'text'},
    {label: 'Artist name', value: 'exhibitor_name_lower', type: 'text'},
    {label: 'Artist first name', value: 'exhibitor_first_name_lower', type: 'text'},
    {label: 'Artist gender', value: 'exhibitor_gender_lower', type: 'gender'},
    {label: 'Artist city', value: 'city_e_lower', type: 'text'},
    {label: 'Artist country', value: 'country_e', type: 'country'},
    {label: 'Exhibition first year', value: 'begin_year_hide', type: 'date'},
    {label: 'Creation year', value: 'year_c1_hide', type: 'date'},
    {label: 'Creation city', value: 'city_c_lower', type: 'text'},
    {label: 'Former country', value: 'country_c_hide', type: 'country'},
    {label: 'Reproduction in catalog', value: 'is_reproduced_in_catalog_hide', type: 'boolean'},
    {label: 'Exhibition space', value: 'space_lower', type: 'text'},
    {label: 'Price', value: 'price_hide', type: 'text'},
    {label: 'Owner', value: 'owner_lower', type: 'text'},
    {label: 'Owner\'s city', value: 'city_o_lower', type: 'text'},
    {label: 'Country\'s owner', value: 'country_o_hide', type: 'country'},
    {label: 'Notes', value: 'notes_lower', type: 'text'},
    {label: 'Exhibition title', value: 'exhibition_title_lower', type: 'text'},
    {label: 'Exhibition group', value: 'exhibition_group_lower', type: 'exhib_group'},
    {label: 'Exhibition city', value: 'city_ex_lower', type: 'text'},
    {label: 'Exhibition country', value: 'country_ex_hide', type: 'country'}
  ]
}



// WEBPACK FOOTER //
// ./src/lang/en_GB/options.js